import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-81138586"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "debug-badge"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_router_outlet = _resolveComponent("ion-router-outlet")!
  const _component_OrientationOverlay = _resolveComponent("OrientationOverlay")!
  const _component_ion_app = _resolveComponent("ion-app")!

  return (_openBlock(), _createBlock(_component_ion_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_router_outlet),
      _createVNode(_component_OrientationOverlay),
      (_ctx.showDebugBadge)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, "DEBUG"))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}